import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { Customer2QualificationEntity } from '../../../entities/mdqx/customer2qualification.entity';
import {
    Customer2QualificationActions,
    Customer2QualificationActionTypes,
} from '../../actions/mdqx/customer2qualification.action';
export interface Customer2QualificationState extends EntityState<Customer2QualificationEntity> {
    fetched: boolean;
}

export const CUSTOMER2QUALIFICATION_KEY = 'customer2Qualification';

const adapter = createEntityAdapter<Customer2QualificationEntity>({
    selectId: e => `${e.CustomerId}_${e.QualificationId}`,
});

const initialState: Customer2QualificationState = adapter.getInitialState({
    fetched: false,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export function customer2QualificationReducer(
    state = initialState,
    action: Customer2QualificationActions,
) {
    switch (action.type) {
        case Customer2QualificationActionTypes.GetResponse: {
            return adapter.setAll(action.Payload, { ...state, fetched: true });
        }

        case Customer2QualificationActionTypes.PostResponse: {
            return adapter.addOne(action.Payload, state);
        }

        case Customer2QualificationActionTypes.DeleteResponse: {
            const id = `${action.Payload.customerId}_${action.Payload.qualificationId}`;
            return adapter.removeOne(id, state);
        }

        default: {
            return state;
        }
    }
}

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectAll } = adapter.getSelectors();

export const selectAllCustomer2Qualifications = selectAll;

export const selectCustomer2QualificationsFetched = (state: Customer2QualificationState) =>
    state.fetched;
